import { render } from "./ViewActions.vue?vue&type=template&id=ff365834&scoped=true"
import script from "./ViewActions.vue?vue&type=script&lang=js"
export * from "./ViewActions.vue?vue&type=script&lang=js"

import "./ViewActions.vue?vue&type=style&index=0&id=ff365834&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff365834"]])

export default __exports__